import { render, staticRenderFns } from "./LangSelector.vue?vue&type=template&id=74cbe2cb&"
import script from "./LangSelector.vue?vue&type=script&lang=js&"
export * from "./LangSelector.vue?vue&type=script&lang=js&"
import style0 from "./LangSelector.vue?vue&type=style&index=0&id=74cbe2cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports